<template lang="pug">
  validation-observer(ref='observer' tag='form')
    div.container-cadastro
      div#passos
        el-steps(:active="passoAtivo" finish-status="success" simple)
          el-step(title="Informar dados da Portaria")
          el-step(title="Confirmar minuta de Portaria")
      div#corpo
        informar-dados(
          v-if="passoAtivo === 0"
          :oficio="oficio")
        confirmar-matricula(
          v-if="passoAtivo === 1"
          :oficio="oficio"
          @getBytesPdf="getBytesPdf"
        )

      app-buttons-cadastro(
        :isPrimeiroPasso="false",
        :isUltimoPasso="ultimoPasso",
        :showButtonCancelar="false",
        :showButtonSalvar="passoAtivo === 0",
        :showButtonDownload="passoAtivo !== 0"
        :showButtonProximo="!ultimoPasso"
        @proximo="proximo",
        @finalizar="finalizar",
        @salvar="salvar",
        @voltar="voltar",
        @download="download"
      )
</template>

<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import InformarDados from '@/screens/arrecadacao/cpat/components/matricula/InformarDados'
import ConfirmarMatricula from '@/screens/arrecadacao/cpat/components/matricula/ConfirmarMatricula'
import FileHelper from '@/utils/fileHelper'
import { mapActions } from 'vuex'

export default {
  components: {
    InformarDados,
    ConfirmarMatricula,
    AppButtonsCadastro
  },
  mixins: [AppNotificacao],
  data () {
    return {
      passoAtivo: 0,
      bytes: []
    }
  },
  computed: {
    ultimoPasso () {
      return this.passoAtivo === 1
    }
  },
  props: {
    oficio: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      salvarPasso: 'oficioArrecadacao/saveMatricula',
      finalizarMatricula: 'oficioArrecadacao/tramitarMatricula',
      getPDFMatricula: 'oficioArrecadacao/getPDFMatricula'
    }),

    getBytesPdf (bytes) {
      this.bytes = bytes
    },

    async salvar () {
      const valido = await this.validarCampos()
      if (valido) {
        const dados = {
          cartorio: {
            id: this.oficio.cartorio.id
          },
          processo: {
            id: this.oficio.processo.id
          }
        }
        try {
          const response = await this.salvarPasso({ dados: dados })
          if (response) {
            this.oficio.id = response.id
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.DADOS_SALVOS_SUCESSO
            )
          }
        } catch (error) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
        }
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_EMISSAO_MINUTA
        )
      }
    },

    async proximo () {
      if (this.passoAtivo === 0) {
        const valido = await this.validarCampos()

        if (valido) {
          await this.salvar()
          this.passoAtivo = this.passoAtivo + 1
        } else {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
          )
        }
      } else {
        this.passoAtivo = this.passoAtivo + 1
      }
    },

    finalizar () {
      this.confirmBox(
        'Deseja confirmar esta ação?',
        this.$messages.TITULO_WARNING,
        () => {
          this.finalizarMatricula(this.oficio.id)
            .then(response => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                response
              )
              this.goToListagem()
            })
            .catch(error => {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                error.message
              )
            })
        },
        () => {},
        'Sim',
        'Não'
      )
    },

    download () {
      const nome = 'documentos_dados_minuta_portaria.pdf'
      FileHelper.saveFile(this.bytes, nome)
    },

    voltar () {
      if (this.passoAtivo !== 0) {
        this.passoAtivo = this.passoAtivo - 1
      } else {
        this.confirmBox(
          'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
          this.$messages.TITULO_WARNING,
          () => {
            this.goToListagem()
          },
          () => {},
          'Sim',
          'Não'
        )
      }
    },
    validarCampos () {
      return this.$refs.observer.validate()
    },
    goToListagem () {
      this.$router.push({
        name: 'cpat/home'
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/matricula/EmissaoMinuta.vue